<template>
  <div :class="selfie.display ? 'has-preview' : null" class="image-input mt-1">
    <img v-if="selfie.display" :src="selfie.display" alt="Image" />
    <div class="image-input-render">
      <button class="btn-remove-image" type="button" @click="resetPicture(selfie)">
        {{ $t('Remove') }}
      </button>
    </div>
    <div class="image-input-empty h-full">
      <div class="camera-capture-frame">
        <div class="p-2 text-white absolute z-20 flex justify-between" @click="changeCamera">
          <svg-vue class="image-input-icon" icon="font-awesome.sync-regular"></svg-vue>
        </div>

        <template v-if="camera === 'frontal'">
          <video ref="videoFront" preload="none" @click="capture(selfie)" class="h-48" />
        </template>
        <template v-if="camera === 'traseira'">
          <video ref="videoBack" preload="none" @click="capture(selfie)" class="h-48" />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WebCam',
  props: {
    value: Blob | String,
  },

  data() {
    return {
      selfie: {
        display: '',
        image: '',
      },
      mediaStreamFront: null,
      mediaStreamBack: null,
      camera: 'frontal',
    };
  },
  computed: {
    isMobile: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
  },
  watch: {
    selfie: {
      handler(display) {},
      deep: true,
    },
  },
  mounted() {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((mediaStream) => {
        this.mediaStreamFront = mediaStream;
        this.$refs.videoFront.srcObject = mediaStream;
        this.$refs.videoFront.play();
        this.changeCamera();
        if (this.$route.params.id && this.value !== null) {
          this.selfie.display = window.app.url + '/storage/' + this.value;
        }
      })
      .catch((error) => console.error('getUserMedia() error:', error));
  },
  methods: {
    uploadImage(file) {
      let reader = new FileReader();
      reader.onloadend = (file) => {
        this.selfie.display = reader.result;
        var ImageURL = this.selfie.display;
        var block = ImageURL.split(';');
        var contentType = block[0].split(':')[1];
        var realData = block[1].split(',')[1];
        var blob = this.b64toBlob(realData, contentType);
        this.selfie.image = blob;
        this.$emit('catchup', blob);
      };
      reader.readAsDataURL(file);
    },
    capture(picture) {
      const reader = new FileReader();
      var mediaStreamTrack = null;
      if (this.camera === 'frontal') {
        mediaStreamTrack = this.mediaStreamFront.getVideoTracks()[0];
      } else if (this.camera === 'traseira') {
        mediaStreamTrack = this.mediaStreamBack.getVideoTracks()[0];
      }
      const imageCapture = new window.ImageCapture(mediaStreamTrack);
      imageCapture.grabFrame().then((imageBitmap) => {
        const canvas = document.createElement('canvas');
        canvas.width = imageBitmap.width;
        canvas.height = imageBitmap.height;
        canvas.getContext('2d').drawImage(imageBitmap, 0, 0);
        const canvasB64 = canvas.toDataURL('image/png');
        const block = canvasB64.split(';');
        const contentType = block[0].split(':')[1];
        const realData = block[1].split(',')[1];
        picture.image = this.b64toBlob(realData, contentType);
        this.$emit('catchup', picture.image);
        reader.onload = (e) => {
          picture.display = e.target.result;
        };
        reader.readAsDataURL(picture.image);
        mediaStreamTrack.stop();
      });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    resetPicture(picture) {
      picture.display = '';
      picture.image = '';
      if (this.camera === 'frontal') {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((mediaStream) => {
            this.mediaStreamFront = mediaStream;
            this.$refs.videoFront.srcObject = mediaStream;
            this.$refs.videoFront.play();
          })
          .catch((error) => console.error('getUserMedia() error:', error));
      } else if (this.camera === 'traseira') {
        navigator.mediaDevices
          .getUserMedia({ video: { facingMode: 'environment' } })
          .then((mediaStream) => {
            this.mediaStreamBack = mediaStream;
            this.$refs.videoBack.srcObject = mediaStream;
            this.$refs.videoBack.play();
          })
          .catch((error) => console.error('getUserMedia() error:', error));
      }
    },
    changeCamera() {
      if (this.camera === 'frontal') {
        this.mediaStreamFront.getVideoTracks()[0].stop();
        this.camera = 'traseira';
        navigator.mediaDevices
          .getUserMedia({ video: { facingMode: 'environment' } })
          .then((mediaStream) => {
            this.mediaStreamBack = mediaStream;
            this.$refs.videoBack.srcObject = mediaStream;
            this.$refs.videoBack.play();
          })
          .catch((error) => console.error('getUserMedia() error:', error));
      } else if (this.camera === 'traseira') {
        this.mediaStreamBack.getVideoTracks()[0].stop();
        this.camera = 'frontal';
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((mediaStream) => {
            this.mediaStreamFront = mediaStream;
            this.$refs.videoFront.srcObject = mediaStream;
            this.$refs.videoFront.play();
          })
          .catch((error) => console.error('getUserMedia() error:', error));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-input {
  @apply relative rounded-md block border bg-white flex justify-center cursor-pointer h-48;

  &.has-preview {
    &:hover {
      .image-input-render {
        @apply inline;
      }
    }
  }

  &:not(.has-preview) {
    &:not(.dragging) {
      &:hover {
        background-size: 30px 30px;
        animation: stripes 2s linear infinite;
        background-image: linear-gradient(
          -45deg,
          theme('colors.blue.100') 25%,
          transparent 25%,
          transparent 50%,
          theme('colors.blue.100') 50%,
          theme('colors.blue.100') 75%,
          transparent 75%,
          transparent
        );
      }
    }

    .image-input-empty {
      @apply inline;
    }
  }

  > img {
    @apply max-w-full max-h-full p-2;
  }

  .image-input-render {
    @apply hidden absolute z-10 bg-gray-900 bg-opacity-50 rounded-md w-full h-full;
  }

  .image-input-empty {
    @apply hidden relative z-10 h-full;
  }

  .camera-capture-frame {
    @apply relative text-gray-700 w-full text-center;
    top: 50%;
    transform: translateY(-50%);
  }

  .image-input-icon {
    @apply h-4 block ml-auto mr-auto;
  }

  .btn-remove-image {
    @apply absolute uppercase border border-2 border-white text-xs text-white py-1 px-2 z-20;
    top: 10px;
    right: 10px;
  }
}

@keyframes stripes {
  from {
    background-position: 0 0;
  }

  to {
    background-position: 60px 30px;
  }
}
</style>
